//-------------------------------------------------------------------------
// 
// !!! Do not edit this file manually !!!
// 
// This file was autogenerated from the Frontier primitives variables
// 
// Run "npm run build-primitives" to rebuild it
// 
//-------------------------------------------------------------------------

import { css } from "./styledSystem";

export const buttonStyles = css`
	display: inline-block;
	font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji";
	font-weight: 600;
	text-align: center;
	vertical-align: middle;
	user-select: none;
	border: 1px solid transparent;

	padding-left: 16px;
	padding-right: 16px;
	padding-top: 8px;
	padding-bottom: 8px;
	font-size: 14px;
	line-height: 1.3;
	border-radius: 4px;

	transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;

	white-space: nowrap;
	appearance: none;
	cursor: pointer;

	&:hover {
		color: inherit;
		text-decoration: none;
	}

	&:focus {
		outline: 0;
		box-shadow: 0 0 0 3px rgba(0,76,199,0.3);
	}

	// Disabled comes first so active can properly restyle
	&.disabled,
	&:disabled {
		cursor: default;
		box-shadow: none !important;
		pointer-events: none;
	}

	// Default coloring
	background-color: #fbfcfd;
	color: #2f363d;
	border-color: #e1e4e8;
	&:hover {
		background-color: #f6f8fa;
		color: #1b1f23;
		border-color: #e1e4e8;
	}
	&:disabled {
		background-color: #f6f8fa;
		color: #959da5;
		border-color: transparent;
	}
	&:active {
		background-color: #e1e4e8;
		color: #2f363d;
		border-color: #e1e4e8;
	}
`;

export const buttonSizes = {
	sm: css`
		padding-top: 6px;
		padding-bottom: 6px;
	`,
	lg: css`
		padding-top: 12px;
		padding-bottom: 12px;
	`,
	font: css`
		font-size: inherit;
		padding-left: 1.25em;
		padding-right: 1.25em;
		padding-top: 0.75em;
		padding-bottom: 0.75em;
	`,
};

export const buttonVariants = {
	primary: css`
		background-color: #4A40FF;
		color: #ffffff;
		border-color: #382EDC;
		&:hover {
			background-color: #5256FF;
			color: #ffffff;
			border-color: #4A40FF;
		}
		&:disabled {
			background-color: #6978FF;
			color: #e1e4e8;
			border-color: transparent;
		}
		&:active {
			background-color: #382EDC;
			color: #ffffff;
			border-color: #382EDC;
		}
	`,
	danger: css`
		background-color: #fbfcfd;
		color: #AE3748;
		border-color: #e1e4e8;
		&:hover {
			background-color: #EF4B62;
			color: #ffffff;
			border-color: #AE3748;
		}
		&:disabled {
			background-color: #f6f8fa;
			color: #F58CA1;
			border-color: transparent;
		}
		&:active {
			background-color: #AE3748;
			color: #ffffff;
			border-color: #AE3748;
		}
	`,
	outline: css`
		background-color: transparent;
		color: #4A40FF;
		border-color: #4A40FF;
		&:hover {
			background-color: #4A40FF;
			color: #ffffff;
			border-color: #4A40FF;
		}
		&:disabled {
			background-color: transparent;
			color: #869AFF;
			border-color: transparent;
		}
		&:active {
			background-color: #382EDC;
			color: #ffffff;
			border-color: #2B22B6;
		}
	`,
	link: css`
		background-color: transparent;
		color: #004CC7;
		border-color: transparent;
		&:hover {
			background-color: transparent;
			color: #004CC7;
			border-color: transparent;
		}
		&:disabled {
			background-color: transparent;
			color: #6a737d;
			border-color: transparent;
		}
		&:active {
			background-color: transparent;
			color: #004CC7;
			border-color: transparent;
		}
	`,
};